import { DEFAULT_LOCALE, Locales } from '../Util/Locales';
import { getEnvConfigByKey } from './EnvConfig';

export const storage = window.localStorage;
export const storageLocaleKey = 'locale';

export const getUrlPrefix = (): string =>
  process.env.REACT_APP_URL_PREFIX || '';

export const getCSCEndpoint = (): string =>
  getEnvConfigByKey('cscDomain') ?? '';

export const getCsaStaticJsUrl = (): string =>
  process.env.REACT_APP_CSA_STATIC_JS_URL ||
  'https://m.media-amazon.com/images/G/01/csa/dist/prod/v2/browser.external-analytics/async.min._TTH_.js';

export const getLocale = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const localeParam = urlParams.get('l');

  let locale: string | null = null;
  if (localeParam != null) {
    const normalizedLocale = localeParam.replace(/_/g, '-');
    const isValid = Locales.some(
      loc => loc[0].toLowerCase() === normalizedLocale.toLowerCase()
    );

    locale = isValid ? normalizedLocale : DEFAULT_LOCALE;
  } else if (storage.getItem(storageLocaleKey)) {
    locale = storage.getItem(storageLocaleKey);
  }

  return locale;
};

export const getCscEntityPrefix = (): string => {
  return getEnvConfigByKey('cscEntityPrefix') ?? 'cscentral_na_user';
};
